import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { createArticleLocationStockAsync, getAllArticleLocationStockByArticleIdAsync, updateArticleLocationStockAsync } from '@application/features/articles/ArticleThunk';
import { getWorkshopLocationAsync } from '@application/features/workorders/workorderThunk';
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import VnButton from '@ui/components/VnButton';
import { selectStyles } from '@ui/styles/select-style';
import { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { NumericFormat } from 'react-number-format';
import { useParams } from 'react-router-dom';
import Select from 'react-select';
const AddArticleLocationStockForm = ({ formData, onClose, updateCase, isStockTabBold }) => {
    const dispatch = useAppDispatch();
    const { id } = useParams();
    const { setValue, handleSubmit, register, watch, control, clearErrors, formState: { errors } } = useForm({
        defaultValues: {
            articleId: parseInt(id)
        }
    });
    useEffect(() => {
        dispatch(getWorkshopLocationAsync());
    }, [dispatch]);
    const { workshopLocationsForArticleLocationStocksDropdown, articleLocationStock } = useAppSelector((state) => state.artical);
    useEffect(() => {
        if (updateCase) {
            setValue('id', articleLocationStock?.id);
            setValue('articleId', articleLocationStock?.articleId);
            setValue('workshopLocationId', articleLocationStock?.workshopLocationId);
            setValue('stock', articleLocationStock?.stock);
        }
    }, [articleLocationStock]);
    const onCreateSubmit = (data) => {
        dispatch(createArticleLocationStockAsync(data))
            .unwrap()
            .then((res) => {
            if (formData.id) {
                dispatch(getAllArticleLocationStockByArticleIdAsync(formData.id))
                    .unwrap()
                    .then((res) => {
                    if (isStockTabBold && res.length > 0) {
                        isStockTabBold(true);
                    }
                    else {
                        isStockTabBold && isStockTabBold(false);
                    }
                });
            }
            onClose();
        })
            .catch((error) => { });
    };
    const onUpdateSubmit = (data) => {
        dispatch(updateArticleLocationStockAsync(data))
            .unwrap()
            .then((res) => {
            if (formData.id) {
                dispatch(getAllArticleLocationStockByArticleIdAsync(formData.id));
            }
            onClose();
        })
            .catch((error) => { });
    };
    return (_jsx(_Fragment, { children: _jsxs("form", { onSubmit: updateCase ? handleSubmit(onUpdateSubmit) : handleSubmit(onCreateSubmit), children: [_jsx("div", { className: 'row mt-4', children: _jsxs("div", { className: 'form-group col-sm-12', children: [_jsx("label", { className: 'form-label vn-text-label', children: "Locatie*" }), _jsx(Controller, { name: 'workshopLocationId', control: control, rules: { required: 'Dit veld is verplicht' }, render: ({ field: { onChange, value } }) => (_jsx(Select, { placeholder: 'Selecteer locatie', isSearchable: true, styles: selectStyles, value: workshopLocationsForArticleLocationStocksDropdown?.find((c) => c.value === value), options: workshopLocationsForArticleLocationStocksDropdown &&
                                        workshopLocationsForArticleLocationStocksDropdown, onChange: (val) => onChange(val?.value), isDisabled: updateCase })) }), errors.workshopLocationId && _jsx("div", { className: 'validation-error', children: errors.workshopLocationId.message })] }) }), _jsx("div", { className: 'row mt-4', children: _jsxs("div", { className: 'form-group col-sm-12', children: [_jsx("label", { className: 'form-label vn-text-label', children: "Voorraad*" }), _jsx(Controller, { name: 'stock', control: control, rules: { required: 'Dit veld is verplicht' }, render: ({ field: { onChange, value } }) => (_jsx(NumericFormat, { placeholder: 'Voer Voorraad', className: 'form-control vn-Input', value: value || '', onValueChange: ({ value }) => {
                                        onChange(value);
                                    }, thousandSeparator: '.', decimalSeparator: ',', decimalScale: 2, allowNegative: true, isAllowed: ({ floatValue }) => floatValue === undefined || (floatValue >= -1 && floatValue <= 999999.99) })) }), errors.stock && _jsx("div", { className: 'validation-error', children: errors.stock.message })] }) }), _jsx("div", { className: 'vn-Form_Footer mt-4', children: _jsxs("div", { style: { display: 'flex', marginLeft: 'auto' }, children: [_jsx(VnButton, { customClassName: 'Vn-cancel-button', mode: 'secondary', onClick: onClose, type: 'button', children: "Annuleren" }), _jsx(VnButton, { customClassName: 'Vn-save-button vn-popup-save-button', mode: 'primary', type: 'submit', children: "Opslaan" })] }) })] }) }));
};
export default AddArticleLocationStockForm;
